// Version : 0.0.1
// Author : AGALAYA
// LastEdit : KARTHEESWARAN
//Last ADD : ISPAISANOWVERFICATION TOGGLE
// MODFIED DATE:18-08-2025
import { takeLatest, put, all, call } from 'redux-saga/effects';

import ProfileTypes from './profile.types';
import {
	profileDetailsGet,
	profileDetailsUpdate,
	passwordUpdate,
	secreteAuthKeyGenerate,
	imageUpdate,
} from './profile.service';
import {
	getProfileDetailsSuccess,
	getProfileDetailsFailure,
	getProfileDetailsResponseChanged,
	updateProfileDetailsSuccess,
	updateProfileDetailsFailure,
	updateProfileDetailsResponseChanged,
	updatePasswordSuccess,
	updatePasswordFailure,
	updatePasswordResponseChanged,
	generateSecreteAuthKeySuccess,
	generateSecreteAuthKeyFailure,
	generateSecreteAuthKeyResponseChanged,
	updateImageSuccess,
	updateImageFailure,
	updateImageResponseChanged,
} from './profile.action';
import { encryptData } from '../_common/enode-decode';

import AlertManager from '../../utils/alertManager';
/** *********************  START PROFILE DETAILS LIST  ******************** */
export function* getProfileDetails({ payload }: any) {
	try {
		const key = 'FetchProfileDetailsKey';
		const { userID, databaseName, userLevel } = payload;
		const jsonData = {
			staffID: userID,
			DatabaseName: databaseName,
			UserLevel: userLevel,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(profileDetailsGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getProfileDetailsFailure(responseData.data));
		} else {
			yield put(getProfileDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getProfileDetailsFailure(error));
	}
}

/** *********************  RESPONSE RESET PROFILE DETAILS LIST  ******************** */
export function* resetProfileDetailsResponse() {
	yield put(getProfileDetailsResponseChanged());
}

/** *********************  GET PROFILE DETAILS LIST  ******************** */
export function* onGetProfileDetails() {
	yield takeLatest(ProfileTypes.GET_PROFILE_DETAILS_START, getProfileDetails);
}

/** ********************* GET RESPONSE RESET PROFILE DETAILS LIST  ******************** */
export function* onGetProfileDetailsResponseReset() {
	yield takeLatest(ProfileTypes.GET_PROFILE_DETAILS_RESPONSE_RESET, resetProfileDetailsResponse);
}

/** *********************  END PROFILE DETAILS LIST  ******************** */

/** *********************  START PROFILE DETAILS UPDATE  ******************** */
export function* updateProfileDetails({ payload }: any) {
	try {
		const {
			companyID,
			userID,
			databaseName,
			companyName,
			companyPhoneNumber,
			companyEmail,
			userPhoneNumber,
			noOfGroupMembers,
			minNoOfGroupMembers,
			maxRuralIncome,
			maxUrbanIncome,
			companyEmergencyNumber,
			provisionType,
			crifDayInterval,
			cbDisbursementDayInterval,
			isThrift,
			isCollectionPhotoNeeded,
			isCollectionLocationNeeded,
			isIndividualSavings,
			isGroupSaving,
			isGroupLoan,
			isExtraChargesVouchers,
			isAuthenticationNeeded,
			isAutoEODNeededSat,
			isAutoEODNeeded,
			isMoratoriumNeeded,
			isGroupAccountNeeded,
			isSubGroupNeeded,
			isGoldLoanAvailed,
			percentageonSellingPrice,
			isIndividualLoanNeeded,
			needJournalEntryAfterEOD,
			auditingToolneededforloan,
			isNachCollectionNeeded,
			sponsorBankCode,
			utilityBankCode,
			primaryAccountHolder,
			isExistingAadharCheck,
			isSkipNomineeExistForCloseLoan,
			isOfficerAttendance,
			isWorkFlowManagementNeeded,
			isDailyEODNeeded,
			isExistingMobileCheck,
			isNeedCoApplicantCBCheckAfterMember,
			isTenureClosedArrearsinDemandCollectionReport,
			isActiveLoanArrearsinDCReport,
			isFinanceApproveNeededforEOD,
			isPhoneNumberVerificationNeeded,
			isPaisanowVerificationNecessary,
			isOTPNeededForMemberAadhar,
			isOTPNeededForNomineeAadhar,
			isOTPNeededForCoApplicantAadhar,
			isExistingCoApplicantAadharCheck,
			isFieldOfficercancheckCreditBureau,
			isBorrowerHighmarkMandatoryForApp,
			isHighmarkMandatoryForApp,
			isProductConfigNeed,
			isSubAccountNeed,
			isTopupLoanNeeded,
			isKYCNeededinWeb,
			isTrainingMandatoryForLoan,
			editActiveLoanMemberDetails,
			isHighmarkDownloadNeededForApp,
			isKYCNeededinMobile,
			isNextFollowUpNeeded,
			isAuditingImageNeeded,
			IsWorkFlowNeeded,
			IsIndividualTrainingNeeded,
			IsRestrictLoanAlreadyExist,
			isLevel1CanApproveHighmarkRejectedMember,
			isLevel2CanApproveHighmarkRejectedMember,
			isLevel3CanApproveHighmarkRejectedMember,
			isLevel4CanApproveHighmarkRejectedMember,
			isLevel6CanApproveHighmarkRejectedMember,
			isCollectionTypeNeeded,
			isRejectionNeedForFieldOfficer,
			isAfterEODCollectionNeededForApp,
			isShowActualDueDate,
			isAuditNotMandatoryForSecondLoan,
			isonlyLeaderSMS,
			isallMemberNotifySMS,
			isduePaymentSMS,
			isonBoardingMemberSMS,
			isoverdueOnEODSMS,
			isonSavingsCollectionSMS,
			userPhoto,
			DefaultPreferredLanguage,
			enachVia,
			isExistingNomineeAadharCheck,
			penaltyChargesBasedOn,
			noOfDaysDelay,
			penalAmount,
			houseVerificationMandatoryForSecondLoan,
			isAadharMaskingNeeded,
			restricttoEditApprovedMember,
			isHouseLocationMandatoryApp,
			isOrderByMeetupTimeNeededInDemandReport,
			isManagerHighmarkMandatoryForApp,
			showAddMemberForLevel1App,
			showAutoLoan,
			isShowLoanAdvance1,
			isShowLoanAdvance2,
			companyApplicationAmount,
			travelAllowance,
			showBusinessLoan,
			showQRPayment,
			isBusinessPhoneNoExist,
			isBusinessAadharExist,
			isBusinessBorrowPhoneNoExist,
			isBusinessBorrowAadharExist,
			isBusinessPartnerPhoneNoExist,
			isBusinessPhoneNoOTPExist,
			isBusinessAadharOTPExist,
			isBusinessBarrowPhoneOTPExist,
			isBusinessBarrowAadharOTPExist,
			isBusinessPartnerPhoneNoOTPExist,
		} = payload;
		const key = 'UpdateProfileDetails';
		const jsonData = {
			CompanyID: companyID,
			StaffID: userID,
			AdminID: userID,
			isGroupSaving: isGroupSaving,
			isAutoEODNeeded: isAutoEODNeeded,
			isGroupLoan: isGroupLoan,
			DatabaseName: databaseName,
			CompanyName: companyName,
			CompanyPhoneNumber: companyPhoneNumber,
			CompanyEmail: companyEmail,
			AdminPhoneNumber: userPhoneNumber,
			NoOfGroupMembers: noOfGroupMembers,
			MinNoOfGroupMembers: minNoOfGroupMembers,
			MaxRuralIncome: maxRuralIncome,
			MaxUrbanIncome: maxUrbanIncome,
			CompanyEmergencyNumber: companyEmergencyNumber,
			ProvisionType: provisionType,
			CrifDayInterval: crifDayInterval,
			CbDisbursementDayInterval: cbDisbursementDayInterval,
			IsThrift: isThrift,
			IsCollectionPhotoNeeded: isCollectionPhotoNeeded,
			IsCollectionLocationNeeded: isCollectionLocationNeeded,
			IsIndividualSavings: isIndividualSavings,
			IsGroupSaving: isGroupSaving,
			IsGroupLoan: isGroupLoan,
			IsExtraChargesVouchers: isExtraChargesVouchers,
			IsAuthenticationNeeded: isAuthenticationNeeded,
			IsAutoEODNeededSat: isAutoEODNeededSat,
			IsAutoEODNeeded: isAutoEODNeededSat,
			IsMoratoriumNeeded: isMoratoriumNeeded,
			IsGroupAccountNeeded: isGroupAccountNeeded,
			IsSubGroupNeeded: isSubGroupNeeded,
			IsGoldLoanAvailed: isGoldLoanAvailed,
			PercentageonSellingPrice: percentageonSellingPrice,
			IsIndividualLoanNeeded: isIndividualLoanNeeded,
			NeedJournalEntryAfterEOD: needJournalEntryAfterEOD,
			AuditingToolneededforloan: auditingToolneededforloan,
			IsNachCollectionNeeded: isNachCollectionNeeded,
			SponsorBankCode: sponsorBankCode,
			UtilityBankCode: utilityBankCode,
			PrimaryAccountHolder: primaryAccountHolder,
			IsExistingAadharCheck: isExistingAadharCheck,
			IsExistingNomineeAadharCheck: isExistingNomineeAadharCheck,
			IsSkipNomineeExistForCloseLoan: isSkipNomineeExistForCloseLoan,
			IsOTPNeededForMemberAadhar: isOTPNeededForMemberAadhar,
			IsOTPNeededForNomineeAadhar: isOTPNeededForNomineeAadhar,
			IsOTPNeededForCoApplicantAadhar: isOTPNeededForCoApplicantAadhar,
			IsExistingCoApplicantAadharCheck: isExistingCoApplicantAadharCheck,
			IsOfficerAttendance: isOfficerAttendance,
			IsWorkFlowManagementNeeded: isWorkFlowManagementNeeded,
			IsDailyEODNeeded: isDailyEODNeeded,
			IsExistingMobileCheck: isExistingMobileCheck,
			IsNeedCoApplicantCBCheckAfterMember: isNeedCoApplicantCBCheckAfterMember,
			IsTenureClosedArrearsinDemandCollectionReport:
				isTenureClosedArrearsinDemandCollectionReport,
			IsActiveLoanArrearsinDCReport: isActiveLoanArrearsinDCReport,
			IsFinanceApproveNeededforEOD: isFinanceApproveNeededforEOD,
			IsPhoneNumberVerificationNeeded: isPhoneNumberVerificationNeeded,
			IsPaisanowVerificationNecessary: isPaisanowVerificationNecessary,
			IsFieldOfficercancheckCreditBureau: isFieldOfficercancheckCreditBureau,
			IsBorrowerHighmarkMandatoryForApp: isBorrowerHighmarkMandatoryForApp,
			IsHighmarkMandatoryForApp: isHighmarkMandatoryForApp,
			IsProductConfigNeed: isProductConfigNeed,
			IsSubAccountNeed: isSubAccountNeed,
			IsTopupLoanNeeded: isTopupLoanNeeded,
			IsKYCNeededinWeb: isKYCNeededinWeb,
			IsTrainingMandatoryForLoan: isTrainingMandatoryForLoan,
			IsEditActiveLoanMember: editActiveLoanMemberDetails,
			IsHighmarkDownloadNeededForApp: isHighmarkDownloadNeededForApp,
			IsKYCNeededinMobile: isKYCNeededinMobile,
			IsNextFollowUpNeeded: isNextFollowUpNeeded,
			IsAuditingImageNeeded: isAuditingImageNeeded,
			IsWorkFlowNeeded: IsWorkFlowNeeded,
			IsIndividualTrainingNeeded: IsIndividualTrainingNeeded,
			RestrictLoanAlreadyExist: IsRestrictLoanAlreadyExist,
			IsLevel1CanApproveHighmarkRejectedMember: isLevel1CanApproveHighmarkRejectedMember,
			IsLevel2CanApproveHighmarkRejectedMember: isLevel2CanApproveHighmarkRejectedMember,
			IsLevel3CanApproveHighmarkRejectedMember: isLevel3CanApproveHighmarkRejectedMember,
			IsLevel4CanApproveHighmarkRejectedMember: isLevel4CanApproveHighmarkRejectedMember,
			IsLevel6CanApproveHighmarkRejectedMember: isLevel6CanApproveHighmarkRejectedMember,
			IsCollectionTypeNeeded: isCollectionTypeNeeded,
			IsRejectionNeedForFieldOfficer: isRejectionNeedForFieldOfficer,
			AfterEODCollectionNeededinMobile: isAfterEODCollectionNeededForApp,
			IsShowActualDueDate: isShowActualDueDate,
			IsAuditNotMandatoryForSecondLoan: isAuditNotMandatoryForSecondLoan,
			IsonlyLeaderSMS: isonlyLeaderSMS,
			IsallMemberNotifySMS: isallMemberNotifySMS,
			IsduePaymentSMS: isduePaymentSMS,
			IsonBoardingMemberSMS: isonBoardingMemberSMS,
			IsoverdueOnEODSMS: isoverdueOnEODSMS,
			IsonSavingsCollectionSMS: isonSavingsCollectionSMS,
			UserPhoto: userPhoto,
			DefaultPreferredLanguage: DefaultPreferredLanguage,
			enachVia: enachVia,
			penaltyChargesBasedOn: penaltyChargesBasedOn,
			noOfDaysDelay: noOfDaysDelay,
			penalAmount: penalAmount,
			isHouseVerificationNeededForSecondLoan: houseVerificationMandatoryForSecondLoan,
			isAadharMaskingNeeded: isAadharMaskingNeeded,
			isRestrictToEditApprovedMember: restricttoEditApprovedMember,
			isHouseLocationMandatoryApp: isHouseLocationMandatoryApp,
			isOrderByMeetupTimeNeededInDemandReport: isOrderByMeetupTimeNeededInDemandReport
				? 1
				: 0,
			isManagerHighmarkMandatoryForApp: isManagerHighmarkMandatoryForApp,
			showAddMemberForLevel1App: showAddMemberForLevel1App,
			showAutoLoan: showAutoLoan,
			IsShowLoanAdvance1: isShowLoanAdvance1,
			IsShowLoanAdvance2: isShowLoanAdvance2,
			CompanyApplicationAmount: companyApplicationAmount,
			TravelAllowance: travelAllowance,
			ShowBusinessLoan: showBusinessLoan,
			ShowQRPayment: showQRPayment,
			IsBusinessPhoneNoExist: isBusinessPhoneNoExist,
			IsBusinessAadharExist: isBusinessAadharExist,
			IsBusinessBorrowPhoneNoExist: isBusinessBorrowPhoneNoExist,
			IsBusinessBorrowAadharExist: isBusinessBorrowAadharExist,
			IsBusinessPartnerPhoneNoExist: isBusinessPartnerPhoneNoExist,
			IsBusinessPhoneNoOTPExist: isBusinessPhoneNoOTPExist,
			IsBusinessAadharOTPExist: isBusinessAadharOTPExist,
			IsBusinessBarrowPhoneOTPExist: isBusinessBarrowPhoneOTPExist,
			IsBusinessBarrowAadharOTPExist: isBusinessBarrowAadharOTPExist,
			IsBusinessPartnerPhoneNoOTPExist: isBusinessPartnerPhoneNoOTPExist,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(profileDetailsUpdate, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateProfileDetailsFailure(responseData.data));
		} else {
			yield put(updateProfileDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateProfileDetailsFailure(error));
	}
}

/** *********************  UPDATE PROFILE DETAILS RESPONSE CHANGED  ******************** */
export function* resetProfileUpdateDetailsResponse() {
	yield put(updateProfileDetailsResponseChanged());
}

/** *********************  UPDATE PROFILE DETAILS  ******************** */
export function* onUpdateProfileDetails() {
	yield takeLatest(ProfileTypes.UPDATE_PROFILE_DETAILS_START, updateProfileDetails);
}

/** *********************  UPDATE PROFILE DETAILS RESPONSE RESET  ******************** */
export function* onUpdateProfileDetailsResponseReset() {
	yield takeLatest(
		ProfileTypes.UPDATE_PROFILE_DETAILS_RESPONSE_RESET,
		resetProfileUpdateDetailsResponse,
	);
}

/** *********************  END PROFILE DETAILS UPDATE  ******************** */

/** *********************  START UPDATE PASSWORD LIST  ******************** */
export function* updatePassword({ payload }: any) {
	try {
		const {
			userID,
			userName,
			companyID,
			userPhoneNumber,
			currentPassword,
			confirmPassword,
			databaseName,
		} = payload;
		const key = 'UpdatePasswordKey';
		const jsonData = {
			UserID: userID,
			UserName: userName,
			CompanyID: companyID,
			UserPhoneNumber: userPhoneNumber,
			CurrentPassword: currentPassword,
			ConfirmPassword: confirmPassword,
			GeneralUserID: userID,
			DatabaseName: databaseName,
			StaffID: userID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(passwordUpdate, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updatePasswordFailure(responseData.data));
		} else {
			yield put(updatePasswordSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updatePasswordFailure(error));
	}
}

/** *********************  RESET PASSWORD DETAILS RESPONSE CHANGED  ******************** */
export function* resetUpdatePasswordResponse() {
	yield put(updatePasswordResponseChanged());
}

/** *********************  UPDATE PASSWORD DETAILS  START  ******************** */
export function* onUpdatePassword() {
	yield takeLatest(ProfileTypes.UPDATE_PASSWORD_START, updatePassword);
}

/** *********************  UPDATE PASSWORD DETAILS  RESPONSE RESET  ******************** */
export function* onUpdatePasswordResponseReset() {
	yield takeLatest(ProfileTypes.UPDATE_PASSWORD_RESPONSE_RESET, resetUpdatePasswordResponse);
}

/** *********************  END UPDATE PASSWORD  ******************** */

/** *********************  START GENERATE SECRETE AUTHKEY ******************** */
export function* generateSecreteAuthKeyQr({ payload }: any) {
	try {
		const { userID, companyID, userPhoneNumber, databaseName } = payload;
		const key = 'GenerateSecreteAuthKey';
		const jsonData = {
			StaffID: userID,
			CompanyID: companyID,
			UserPhoneNumber: userPhoneNumber,
			DatabaseName: databaseName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(secreteAuthKeyGenerate, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(generateSecreteAuthKeyFailure(responseData.data));
		} else {
			yield put(generateSecreteAuthKeySuccess(responseData.data));
		}
	} catch (error) {
		yield put(generateSecreteAuthKeyFailure(error));
	}
}

/** ********************* RESET GENERATE PASSWORD DETAILS  RESPONSE   ******************** */
export function* resetGenerateSecreteAuthKeyResponse() {
	yield put(generateSecreteAuthKeyResponseChanged());
}

/** ********************* GENERATE SECRETE AUTH KEY START   ******************** */
export function* onGenerateSecreteAuthKey() {
	yield takeLatest(ProfileTypes.GENERATE_SECRETE_AUTHKEY_START, generateSecreteAuthKeyQr);
}

/** ********************* GENERATE SECRETE AUTH KEY RESPONSE RESET   ******************** */
export function* onGenerateSecreteAuthKeyResponseReset() {
	yield takeLatest(
		ProfileTypes.GENERATE_SECRETE_AUTHKEY_RESPONSE_RESET,
		resetGenerateSecreteAuthKeyResponse,
	);
}
/** *********************  END GENERATE SECRETE AUTHKEYFUN  ******************** */

/** *********************  START UPDATE IMAGE LIST  ******************** */
export function* updateImage({ payload }: any) {
	try {
		const { userID, companyID, userPhoneNumber, userPhoto, databaseName } = payload;
		const key = 'ProfileImageUpdateKey';
		const jsonData = {
			StaffID: userID,
			CompanyID: companyID,
			UserPhoneNumber: userPhoneNumber,
			UserPhoto: userPhoto,
			DatabaseName: databaseName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(imageUpdate, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateImageFailure(responseData.data));
		} else {
			yield put(updateImageSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateImageFailure(error));
	}
}

/** ********************* UPDATE IMAGE RESPONSE CHANGED   ******************** */
export function* resetUpdateImageResponse() {
	yield put(updateImageResponseChanged());
}

/** ********************* UPDATE IMAGE START   ******************** */
export function* onUpdateImage() {
	yield takeLatest(ProfileTypes.UPDATE_IMAGE_START, updateImage);
}

/** ********************* UPDATE IMAGE RESPONSE RESET   ******************** */
export function* onUpdateImageResponseReset() {
	yield takeLatest(ProfileTypes.UPDATE_IMAGE_RESPONSE_RESET, resetUpdateImageResponse);
}

/** *********************  END UPDATE PASSWORD  ******************** */

/** ********************* PROFILE SAGA CALL STARRT ******************** */
export function* profileSaga() {
	yield all([
		call(onGetProfileDetails),
		call(onGetProfileDetailsResponseReset),
		call(onUpdateProfileDetails),
		call(onUpdateProfileDetailsResponseReset),
		call(onUpdatePassword),
		call(onUpdatePasswordResponseReset),
		call(onGenerateSecreteAuthKey),
		call(onGenerateSecreteAuthKeyResponseReset),
		call(onUpdateImage),
		call(onUpdateImageResponseReset),
	]);
}
/** ********************* PROFILE SAGA CALL END ******************** */
